import { useActionButtonContext } from '@aibees/elephant/context/action-button-context';
import { ErrorResponse } from '@aibees/shared/definition';
import { UseMutationResult } from '@tanstack/react-query';
import { useMemo } from 'react';
import { PeopleTableInfo } from '../../feature/search-table-people';
import { ENRICHMENT_STATE } from '../../types';
import { SaveRecordRequest } from '../types';

export function useContactDetailsEnrichmentStatus(
  saveApi?: UseMutationResult<void, ErrorResponse, SaveRecordRequest, any>,
  people?: PeopleTableInfo
) {
  const state = people?.revelation?.contact?.state;
  const { isItemProcessing } = useActionButtonContext();

  return useMemo(() => {
    const failed = state === ENRICHMENT_STATE.FAILED;
    const unlocked = !!state;
    const disabled = !people;
    return { failed, unlocked, disabled };
  }, [people, saveApi?.isLoading, saveApi?.status, state, isItemProcessing]);
}
